/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { EnumFieldDisplay } from "./display";
import { EnumFieldEdit } from "./edit";

const EnumField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EnumFieldDisplay />,
        editComponent: <EnumFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
EnumField.displayName = "EnumField";
export { EnumField };
